import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, CalendarDays, MapPin, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/date";

function fmtDate(iso) {
  return fmtDateTime(iso);
}

// Highlighted strip of admin-pinned events, scoped to the signed-in user's country.
export default function FeaturedEvents() {
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.country) return;
    api.get("/events/featured", { params: { country: user.country } })
      .then((r) => setEvents(r.data)).catch(() => {});
  }, [user]);

  if (!events.length) return null;

  return (
    <section className="mb-10" data-testid="featured-events">
      <div className="flex items-center gap-2 mb-4">
        <Star className="w-5 h-5 text-[#E6B34A]" fill="currentColor" />
        <h2 className="font-display font-extrabold text-lg lg:text-2xl tracking-tight">Featured Events</h2>
        <button onClick={() => navigate("/events")} className="ml-auto text-sm text-[#E6B34A] font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all">
          All events <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map((ev) => (
          <button
            key={ev.id}
            onClick={() => navigate("/events")}
            data-testid={`featured-event-${ev.id}`}
            className="text-left rounded-2xl border border-[#E6B34A]/30 bg-gradient-to-br from-[#E6B34A]/10 to-transparent overflow-hidden hover:border-[#E6B34A]/60 transition-colors"
          >
            {ev.has_cover && <img src={`${api.defaults.baseURL}/events/${ev.id}/cover`} alt={ev.title} className="w-full h-28 object-cover" />}
            <div className="p-5">
              <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#E6B34A]/20 text-[#E6B34A]">★ {ev.event_type}</span>
              <h3 className="font-display font-bold text-lg tracking-tight mt-2 leading-tight">{ev.title}</h3>
              <p className="text-sm text-[#E6B34A] mt-2 flex items-center gap-1.5"><CalendarDays className="w-4 h-4" /> {fmtDate(ev.starts_at)}</p>
              <p className="text-sm text-zinc-400 mt-1 flex items-center gap-1.5"><MapPin className="w-4 h-4 shrink-0" /> {[ev.city, ev.country].filter(Boolean).join(", ")}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
